/* eslint-disable max-len */
import React from 'react';

export const SquareThreeStackOutline = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            aria-hidden='true'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.644 1.59a.75.75 0 01.712 0l9.75 5.25a.75.75 0 010 1.32l-2.953 1.59 2.953 1.59a.75.75 0 010 1.32l-2.953 1.59 2.953 1.59a.75.75 0 010 1.32l-9.75 5.25a.75.75 0 01-.712 0l-9.75-5.25a.75.75 0 010-1.32l2.953-1.59-2.953-1.59a.75.75 0 010-1.32l2.953-1.59-2.953-1.59a.75.75 0 010-1.32l9.75-5.25zM6.43 10.602L3.832 12 12 16.398 20.168 12l-2.597-1.398-5.215 2.808a.75.75 0 01-.712 0L6.43 10.602zm0 4.5L3.832 16.5 12 20.898l8.168-4.398-2.597-1.398-5.215 2.808a.75.75 0 01-.712 0L6.43 15.102zM3.832 7.5L12 11.898 20.168 7.5 12 3.102 3.832 7.5z'
                fill='currentcolor'
            />
        </svg>
    );
};
